import React, { useEffect, useRef } from 'react';
import * as bootstrap from 'bootstrap';
import "./home-banner.css"

const HomeCarousel: React.FC = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const homeBanner1 = "https://www.growniverse.com/images//home-banner4.webp";
  const homeBanner2 = "https://www.growniverse.com/images//home-banner2.webp";
  const homeBanner3 = "https://www.growniverse.com/images//home-banner3.webp";
  const homeBanner5 = "https://www.growniverse.com/images//home-banner5.webp";
  const homeBanner6 = "https://www.growniverse.com/images//home-banner6.webp";
  const homeBanner7 = "https://www.growniverse.com/images//home-banner7.webp";
  const homeBanner8 = "https://www.growniverse.com/images//home-banner8.webp";
  const homeBanner9 = "https://www.growniverse.com/images//home-banner9.webp";
  useEffect(() => {
    const carousel = new bootstrap.Carousel(carouselRef.current, {
      interval: 2000,
      ride: 'carousel',
      pause: false,
      wrap: true,
    });
    return () => carousel.dispose();
  }, []);

  const imageStyle = {
    height: '100%',
    width: '100%',
    objectFit: 'cover' as const,
  };

  const overlayStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: '#fff',
    textAlign: 'center',
    zIndex: 2,
    textShadow: '0 2px 10px rgba(0,0,0,0.7)',
    width: "80%"
  };

  const itemStyle: React.CSSProperties = {
    position: 'relative',
    height: '100%',
  };

  return (
    <div
      id="homeCarousel"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      ref={carouselRef}
    >
      <div className="carousel-inner" style={{ height: '700px', overflow: 'hidden' }}>

        <div className="carousel-item" style={itemStyle}>
          <img src={homeBanner1} alt="Banner 3" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1 style={{ color: "black" }}>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
        <div className="carousel-item active" style={itemStyle}>
          <img src={homeBanner9} alt="Banner 1" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1 style={{ color: "white" }}>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
        <div className="carousel-item" style={itemStyle}>
          <img src={homeBanner2} alt="Banner 2" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
        <div className="carousel-item" style={itemStyle}>
          <img src={homeBanner3} alt="Banner 3" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1 style={{ color: "white" }}>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
        <div className="carousel-item" style={itemStyle}>
          <img src={homeBanner7} alt="Banner 3" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1 style={{ color: "black" }}>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
        <div className="carousel-item" style={itemStyle}>
          <img src={homeBanner8} alt="Banner 3" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1 style={{ color: "white" }}>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
        <div className="carousel-item" style={itemStyle}>
          <img src={homeBanner6} alt="Banner 3" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1 style={{ color: "black" }}>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
        <div className="carousel-item" style={itemStyle}>
          <img src={homeBanner5} alt="Banner 3" className="HomeBannerImg" />
          <div style={overlayStyle}>
            <h1 style={{ color: "white" }}>Best Education from your Home</h1>
            <p>Don't change your learning, just change the way.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCarousel;
